// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__AJsX2","content":"Layout_content__UOgH6","fullscreen":"Layout_fullscreen__eHCYp"};